const initialState = {
    groupSetups: [],
    groupNames: [],
    gridGroupSetupConfiguration: {
        fielddata: [],
        instances: [],
    },
    mappedDataDictionaries: [],
    unMappedDataDictionaries: [],
    linkedMappedDataDictionaries: [],
    linkedUnMappedDataDictionaries: [],

    groupFieldSourceMappings: [],
    defaultSelectedSources: [],
    selectedSourceNames: [],
    resetMappedDD: [],
    groupDDConfigs: [],
    gcRuleNames: [],
    linkGroupIndex: '',
    groupSettings: [],
};

export default initialState;
